export const getAllPosts = `query AllPosts($host: String!, $after: String) {
  publication(host: $host) {
    title
    posts(first: 9, after: $after) {
      edges {
        node {
          id
          title
          brief
          url
          publishedAt
          slug
          coverImage {
            url
          }
          tags {
            slug
            name
          }
          seo {
            title
            description
          }
          author {
            username
            id
            name
            profilePicture
          }
          readTimeInMinutes
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}`;

export const getSinglePost = `query GetPostBySlug($host: String!, $slug: String!, $after: String) {
  publication(host: $host) {
    post(slug: $slug) {
      id
      slug
      title
      subtitle
      author {
        id
        username
        name
        bio {
          html
        }
        profilePicture
      }
      tags {
        name
        slug
      }
      url
      publishedAt
      content {
        html
      }
      coverImage {
        url
      }
      readTimeInMinutes
      seo {
        title
        description
      }
      views
      series {
        id
        name
        slug
      }
      reactionCount
      comments(first: 100, after: $after, sortBy: RECENT) {
        edges {
          node {
            id
            content {
              text
            }
            author {
              id
              name
              username
            }
            dateAdded
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalDocuments
      }
    }
  }
}`;

export const getAllTitles = `query AllTitles($host: String!, $after: String) {
  publication(host: $host) {
    posts(first: 20, after: $after) {
      edges {
        node {
          id
          publishedAt
          updatedAt
          slug
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}`;